// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  erudaEnabled: false,
  API_URL: 'https://api-m-dev.riptec.host:8443/anton.o/api1/1.2.0/',
  /*
  API_URL: 'http://virtserver.swaggerhub.com/anton.o/api1/1.2.0/',
  
  */
  BASE_API_URL_ACTIVE_Q: 'https://ripdialer.riptec.host:42089/activeq/',
  BASE_API_URL_ACD: 'https://acd1.riptec.host/dev8/',
  // LIVE_API_URL: 'http://api-m-dev.riptec.host:8082/anton.o/api1/1.2.0/',
  LIVE_API_URL: 'https://api-m-dev.riptec.host:8443/anton.o/api1/1.2.0/',
  //LIVE_API_URL: 'http://localhost:8083/anton.o/api1/1.2.0/',
};
// LIVE_API_URL: 'http://api-m-dev.riptec.host:8082/anton.o/api1/1.2.0/'

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
